export const whatsNewKeys = {
  all: ['whatsNew'] as const,
  lists: () => [...whatsNewKeys.all, 'list'] as const,
  list: () => [...whatsNewKeys.lists()] as const,
  details: () => [...whatsNewKeys.all, 'detail'] as const,
  detail: (id: string | undefined) => [...whatsNewKeys.details(), id] as const,
}
